import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { VAM_SERVICE } from '@eggplant/api-hosts'

interface Props {
  id: string
  onSuccess: () => void
  children?: () => void
}

const DeleteGitConnectionRequest = ({
  id,
  onSuccess,
  children
}: Props) => {
  const url = `${VAM_SERVICE}/repositories/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='delete'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default DeleteGitConnectionRequest
